import { get, isEmpty, map } from "lodash";
import moment from "moment-timezone";
import { NOTIFICATION_LIST_DATE } from "../constants";

export const trimLower = (str) => {
  return str ? str.trim().replace(/\s+/g, "-").toLowerCase() : null;
};

export const humanize = (str) => {
  var frags = str.split("-");
  for (let i = 0; i < frags.length; i++) {
    frags[i] = frags[i].charAt(0).toUpperCase() + frags[i].slice(1);
  }
  return frags.join(" ");
};

export const downloadFile = (data, fileName) => {
  const a = document.createElement("a");
  a.href = data;
  a.download = fileName;
  a.click();
};

export const getRandomColor = () => {
  var letters = "0123456789ABCDEF";
  var color = "#";
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * 16)];
  }
  return color;
};

export const mapOrder = (array, order, key) => {
  array.sort(function (a, b) {
    let A = a[key],
      B = b[key];

    if (order?.indexOf(A) > order?.indexOf(B)) {
      return 1;
    } else {
      return -1;
    }
  });

  return array;
};

export const displaySequential = (data) => {
  data?.sort((a, b) => {
    let first = JSON.parse(a.value);
    let second = JSON.parse(b.value);
    return first.sequenceNo - second.sequenceNo;
  });

  return data;
};

export const displayRating = (data, selected) => {
  const fetchRatings = (displaySequential(data) || []).find(
    (i) => i.name === selected
  );

  const parsedJson = !isEmpty(get(fetchRatings, "value"))
    ? JSON.parse(get(fetchRatings, "value"))
    : "";

  const { rating } = { ...parsedJson };
  return rating;
};

export const complexityAttempts = () => {
  const passwordComplexity = localStorage.getItem("passwordComplexity");

  let attempts = 1;
  if (passwordComplexity === "LOW") {
    attempts = 7;
  } else if (passwordComplexity === "MEDIUM") {
    attempts = 6;
  } else if (passwordComplexity === "HIGH") {
    attempts = 5;
  }

  return attempts;
};

export const manageLoginAttempts = (formData) => {
  let storageAttempts =
    localStorage.getItem("loginAttempts") &&
    JSON.parse(localStorage.getItem("loginAttempts"));

  let loginAttempts = {
    email: formData.email,
    createdAt: new Date(),
    attempt: 1,
  };

  if (storageAttempts && formData.email !== storageAttempts.email) {
    localStorage.removeItem("loginAttempts");
    storageAttempts = null;
  }

  loginAttempts = storageAttempts
    ? {
        ...storageAttempts,
        attempt: storageAttempts.attempt + 1,
        email: formData.email,
        createdAt: new Date(),
      }
    : loginAttempts;

  localStorage.setItem("loginAttempts", JSON.stringify(loginAttempts));
  return loginAttempts;
};

export const urlContentToDataUri = (url) => {
  return fetch(url, {
    method: "GET",
    headers: { "Cache-Control": "no-cache" },
  })
    .then((response) => response.blob())
    .then(
      (blob) =>
        new Promise((callback) => {
          let reader = new FileReader();
          reader.onload = function () {
            callback(this.result, blob);
          };
          reader.readAsDataURL(blob);
        })
    );
};

export const getGridColumns = (columns) => {
  const filtered = columns?.filter((item) => item.show);
  return map(filtered, "field");
};

export const getDefaultGridColumns = (columns) => {
  const filtered = columns?.filter((item) => item.isDefault);
  return map(filtered, "field");
};

export const manageGridColumns = (columns, filter) => {
  let orderedColumns = mapOrder(columns, filter.columns, "field");

  return orderedColumns.map((item) => {
    const show = filter?.columns?.includes(item.field);
    return { ...item, show };
  });
};

export const currentYear = new Date().getFullYear();
export const yearRange = (start, stop, step) =>
  Array.from({ length: (stop - start) / step + 1 }, (_, i) => start + i * step);

export const strengthType = () => [
  { name: "MyStrengths", value: "My strength" },
];

export const getBrowserTime = (dateTime, format) => {
  const notificationTime = moment(dateTime);
  const notificationTimeZone = moment.tz.guess(); // user's timezone
  const notificationDate = notificationTime
    .clone()
    .tz(notificationTimeZone)
    .format(format);

  return notificationDate;
};

export const targetStatusColor = {
  Hold: "#C358A3",
  Draft: "#868686",
  Active: "#56CE32",
  Overdue: "#D60303",
  Completed: "#00CEAD",
  Planned: "#5366D3",
  Incomplete: "#83617F",
  Archived: "#A2ADBC",
  Pending: "#EF7713",
};

export const isEmptyArray = (array) => {
  return (
    Array.isArray(array) && (array.length == 0 || array.every(isEmptyArray))
  );
};
